module.exports = __webpack_public_path__ + "img/yo.7788fab1.webp";